
import React from 'react';
import { SelectBox } from '../SelectBox/index';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import './index.css';

export const SelectBoxsContainer = (prop) => {
  const { filters, updateConstraints } = prop;
  const onFilterChange = (value) => {
    updateConstraints(value);
  }

  return ( 
     <>{filters.map((f, i) => <SelectBox key={i} filterData={f} onFilterChange={onFilterChange} />)}</>
  );
}
